<template>
  <nav class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-1">
    <div class="flex items-center justify-around">
      <NuxtLink
        v-for="item in navItems"
        :key="item.path"
        :to="item.path"
        class="flex flex-col flex-1 items-center px-8 py-2 rounded-lg transition-all duration-200"
        :class="getNavItemClass(item.path)"
      >
        <Icon
          :name="item.icon"
          size="24"
          class="transition-colors duration-200"
        />
      </NuxtLink>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'

interface NavItem {
  path: string
  icon: string
  label: string
}

const route = useRoute()

// 导航项配置
const navItems: NavItem[] = [
  {
    path: '/',
    icon: 'heroicons:home',
    label: '首页',
  },
  {
    path: '/library',
    icon: 'heroicons:rectangle-stack',
    label: '卡片库',
  },
]

// 获取导航项样式 - 使用冷淡色调
function getNavItemClass(path: string) {
  // 检查当前路由是否匹配导航项
  const isActive = path === '/'
    ? route.path === '/'
    : route.path.startsWith(path)

  return isActive
    ? 'text-slate-700'
    : 'text-slate-400 hover:text-slate-500 hover:bg-slate-50'
}
</script>
